<p-panel id="driverChecklist" styleClass="panel-shadow" *ngIf="task">
  <p-header> Driver Checklist</p-header>

  <div class="checklist-name mb-2" *ngIf="checklist?.name.length > 0">
    <strong>
      {{ checklist?.name }}
    </strong>
  </div>

  <div class="flex flex-wrap grid-gap-10">
    <div class="checklist-panel">
      <p-fieldset>
        <p-header class="" style="position: relative; margin-bottom: 0">
          <div style="font-weight: bold; font-size: 18px; color: var(--textColor)">Pick-up</div>
        </p-header>
        <ng-container
          *ngTemplateOutlet="
            checklist_steps_template;
            context: { $implicit: driverChecklistPickUp }
          "
        ></ng-container>
      </p-fieldset>
    </div>
    <div class="checklist-panel">
      <p-fieldset>
        <p-header style="position: relative; margin-bottom: 0">
          <div style="font-weight: bold; font-size: 18px; color: var(--textColor)">Drop-off</div>
        </p-header>
        <ng-container
          *ngTemplateOutlet="
            checklist_steps_template;
            context: { $implicit: driverChecklistDropOff }
          "
        ></ng-container>
      </p-fieldset>
    </div>
  </div>
  <div *ngIf="showManualEditBtn">
    <div class="grid checklist-actions">
      <div class="p-2">
        <button
          (click)="checklistManualEdit()"
          [disabled]="manualEditDisabled"
          [pTooltip]="checklistDisabledReason"
          [label]="isDriverChecklistManualEdit ? 'End Edit' : 'Manual Edit'"
          class="ui-button btn-mobile-block"
          pButton
          type="button"
        ></button>

        <button
          (click)="onPauseResumeTask(isJobPaused)"
          *ngIf="showPauseResumeBtn"
          [disabled]="organisationTypeId == OrganisationType.Engineius && isJobCompleted"
          icon="{{ isJobPaused ? 'fa fa-play' : 'fa fa-pause' }}"
          label="{{ isJobPaused ? 'Resume Task' : 'Pause Task' }}"
          class="ui-button btn-mobile-block"
          ngClass="{{ isJobPaused ? 'green-btn' : 'ui-button-secondary' }}"
          pButton
        ></button>
      </div>
    </div>
  </div>
</p-panel>

<ng-template #checklist_steps_template let-checklistSteps>
  <!--  <ng-container *ngIf="asChecklistSteps(checklistStepsUntyped) as checklistSteps">-->
  <ul class="list-group">
    <li *ngFor="let step of checklistSteps" class="list-group-item">
      <ng-container *ngTemplateOutlet="step_template; context: { $implicit: step }"></ng-container>
    </li>
  </ul>
  <!--  </ng-container>-->
</ng-template>

<ng-template #step_template let-stepUntyped>
  <ng-container *ngIf="asChecklistStep(stepUntyped) as step">
    <div class="ui-g-12 step-name">
      <div class="d-flex">
        <div class="flex-grow-1">
          <p-checkbox
            (onChange)="stepCompleteToggled(step)"
            [(ngModel)]="step.isComplete"
            [disabled]="!isDriverChecklistManualEdit || isJobPaused || step.id == 0"
            [label]="step.title"
            binary="true"
          ></p-checkbox>
        </div>

        <div
          (click)="handleShowCurrentLocation(step)"
          *ngIf="step.completedDateTime && step.latitude && step.longitude"
          class="flex-shrink-1"
        >
          <span class="fa fa-map-marker link fa-15x"></span>
        </div>

        <div
          *ngFor="let pausePhoto of step.pausePhotos; let i = index"
          (click)="openPausePhotos(step.pausePhotos, i)"
          class="flex-shrink-1 ml-2"
        >
          <span class="fa fa-image link fa-15x cursor-pointer"></span>
        </div>
      </div>
    </div>

    <div class="mt-1 flex justify-content-between w-full">
      <small *ngIf="step?.completedDateTime" class="text-gray-500 ml-5">
        {{ step?.completedDateTime | datex : "ddd DD MMM 'YY HH:mm" }}
      </small>
      <span>
        {{ step?.customStepConfig?.ancillaryStepName }}
      </span>
    </div>

    <div *ngIf="step?.description?.length > 0" class="ui-g-12 cursor-pointer">
      <div class="d-flex">
        <div
          [class.description-expanded]="step?.showDescription"
          class="flex-grow-1 description-field"
          id="stepDescription-{{ step.id }}"
        >
          {{ step?.description }}
        </div>

        <div (click)="toggleStepDescription(step)" *ngIf="canToggle(step)" class="flex-shrink-1">
          <div class="pl-2 less-more">
            <span *ngIf="!step?.showDescription">read more</span>
            <span *ngIf="step?.showDescription">read less</span>
          </div>
        </div>
      </div>
    </div>

    <div class="clearfix"></div>

    <small
      (click)="showEnhancedStepDetails(step)"
      class="link-style ml-5 cursor-pointer"
      *ngIf="step.isEnhancedStep"
    >
      Enhanced Step Details
    </small>

    <div class="clearfix"></div>
  </ng-container>
</ng-template>

<p-dialog
  [header]="toggleCompleteHeader"
  [(visible)]="showToggleStepCompleteConfirm"
  [style]="{ width: '500px' }"
  [modal]="true"
  [closable]="false"
>
  <div *ngIf="stepToToggle">
    <div *ngIf="showUndoWarning">
      Un-ticking this step will result in the loss of data from the task. Do you want to continue?
    </div>
    <div *ngIf="stepToToggle.isComplete">
      <div class="text-warning mb-2" *ngIf="!stepToToggle.isCustomStep">
        When manually completing an Engineius step, the time should be as accurate as possible as it
        will affect metrics/reports
      </div>
      <div class="font-bold mb-2">Select Step Completed Time:</div>
      <p-calendar
        [(ngModel)]="stepToToggle.completedDateTime"
        [showIcon]="true"
        [showOnFocus]="true"
        [showTime]="true"
        [inline]="true"
        appendTo="body"
        dateFormat="dd/mm/yy"
      >
      </p-calendar>
    </div>
  </div>
  <p-footer>
    <div class="button-box">
      <button
        type="button"
        pButton
        label="Save"
        class="btn-to-right"
        [disabled]="!stepToToggle?.completedDateTime || isSavingStep"
        (click)="saveStepCompleted(stepToToggle)"
      ></button>
      <button
        (click)="onToggleCancel(stepToToggle)"
        class="ui-button btn-to-right ui-button-tertiary"
        label="Cancel"
        pButton
        type="button"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog
  header="Current Location"
  [(visible)]="showCurrentLocationDialog"
  [style]="{ width: '500px' }"
  [modal]="true"
  closable="true"
  *ngIf="selectedStep"
>
  <map-control [readOnlyMode]="ReadOnlyMode.ReadOnly" [(origin)]="currentLocation"></map-control>
</p-dialog>

<p-dialog
  header="Pause Reason"
  [(visible)]="showPauseReasonDialog"
  [style]="{ width: '500px' }"
  [modal]="true"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row">
      <div class="ui-g-6">
        <strong> Please select a reason: </strong>
      </div>
      <div class="ui-g-6">
        <p-dropdown
          appendTo="body"
          name="pauseReason"
          placeholder="Please select a reason"
          [options]="pauseReasons"
          [(ngModel)]="pauseReasonId"
          [style]="{ width: '100%' }"
        ></p-dropdown>
      </div>
    </div>

    <div class="ui-grid-row pull-right mt-4">
      <button
        type="button"
        pButton
        label="Cancel"
        class="ui-button btn-to-right ui-button-tertiary"
        (click)="showPauseReasonDialog = false"
      ></button>
      <button
        type="button"
        class="ui-button btn-to-right"
        pButton
        (click)="pauseResumeTask()"
        label="Done"
      ></button>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Enhanced Checklist Details"
  [(visible)]="showEnhancedChecklistStepDialog"
  [style]="{ width: '500px' }"
  [modal]="true"
>
  <div *ngIf="stepToPreview">
    <p>{{ stepToPreview.customStepConfig?.prompt }}</p>
    <div class="pl-2">
      <div *ngFor="let answerSection of stepToPreview.answerSections">
        <p-fieldset [legend]="answerSection.label">
          <span *ngIf="answerSection.text">
            {{ answerSection.text }}
          </span>

          <div class="grid mt-2 grid-gap-5 ml-4" *ngIf="answerSection.photos?.length > 0">
            <div *ngFor="let photoLocation of answerSection.photos">
              <a (click)="openPhoto(photoLocation)"
                ><img [src]="photoLocation" style="height: 50px; width: 50px" alt=""
              /></a>
            </div>
          </div>

          <div class="ui-g-12" *ngIf="answerSection.options">
            <div *ngFor="let option of answerSection.options" class="mb-2">
              <p-checkbox
                [(ngModel)]="option.isSelected"
                [disabled]="true"
                [ngModelOptions]="{ standalone: true }"
                binary="true"
                label="{{ option?.text }}"
                name="isSelected"
              ></p-checkbox>
              <div class="grid mt-2 grid-gap-5 ml-4" *ngIf="option.photos?.length > 0">
                <div *ngFor="let photo of option.photos">
                  <a (click)="openPhoto(photo.location)"
                    ><img [src]="photo.location" style="height: 50px; width: 50px" alt=""
                  /></a>
                </div>
              </div>
            </div>
          </div>
        </p-fieldset>
      </div>
    </div>
  </div>
</p-dialog>

<ngx-gallery
  *ngIf="customStepPhotos.length > 0"
  [options]="customStepGalleryOptions"
  [images]="customStepPhotos"
  (previewClose)="clearCustomStepPhoto()"
></ngx-gallery>
